var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCommunityFilled = function SvgCommunityFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.668 11c1.066 0 2.095.356 2.894 1 .8.646 1.313 1.536 1.446 2.504l.7 5.124c.057.422.016.85-.121 1.257a2.942 2.942 0 0 1-.675 1.1 3.277 3.277 0 0 1-1.11.75 3.538 3.538 0 0 1-1.35.265H9.28c-.465 0-.925-.09-1.349-.265a3.277 3.277 0 0 1-1.11-.75 2.942 2.942 0 0 1-.675-1.1 2.757 2.757 0 0 1-.12-1.257l.699-5.124c.132-.968.646-1.858 1.446-2.503A4.615 4.615 0 0 1 11.065 11h1.603ZM8 5a4 4 0 1 1 8 0 4 4 0 0 1-8 0Z",
    fill: "#2955DE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 9a3 3 0 1 1 6 0 3 3 0 0 1-6 0Z",
    fill: "#96C1FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 9a3 3 0 1 1 6 0 3 3 0 0 1-6 0Z",
    fill: "#C5DEFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.695 13H5a1 1 0 0 1 .986 1.165l-1 6A1 1 0 0 1 4 21h-.5c-.373 0-.958-.073-1.4-.278a3 3 0 0 1-1.698-3.215l.333-2A3 3 0 0 1 3.695 13Z",
    fill: "#96C1FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.264 13.323A1 1 0 0 1 19 13h1.306a3 3 0 0 1 2.96 2.507l.332 2A3.002 3.002 0 0 1 20.64 21H19.5a1 1 0 0 1-.997-.917l-.5-6a1 1 0 0 1 .261-.76Z",
    fill: "#C5DEFF"
  })));
};
export default SvgCommunityFilled;